<template>
    <div v-wechat-title="'mysread'">

        <!--頂部欄-->
        <div class="top-nav-container">
            <span id="selected" @click="selected" style="color: #EA477B">精選</span>
            <span id="ranking" @click="ranking" style="margin-left: 10px;margin-right: 10px">榜單</span>
            <span id="bookRoom" @click="bookRoom">書庫</span>
            <img @click="search" src="../assets/img_search.png" style="position: absolute;right: 10px;top: 25%;cursor: pointer;width: 8%" />
        </div>

        <router-view></router-view>

    </div>
</template>

<script>
export default {
    name: "BookCityVue",
    methods: {
        //精選
        selected: function () {
            document.getElementById("selected").style.color = "#EA477B";
            document.getElementById("ranking").style.color = "#000000";
            document.getElementById("bookRoom").style.color = "#000000";

            this.$router.push({
                path: "SelectedVue",
            });
        },

        //榜單
        ranking: function () {
            document.getElementById("selected").style.color = "#000000";
            document.getElementById("ranking").style.color = "#EA477B";
            document.getElementById("bookRoom").style.color = "#000000";

            this.$router.push({
                path: "RankingVue",
            });
        },

        //書庫
        bookRoom: function () {
            document.getElementById("selected").style.color = "#000000";
            document.getElementById("ranking").style.color = "#000000";
            document.getElementById("bookRoom").style.color = "#EA477B";

            this.$router.push({
                path: "BookRoomVue",
            });
        },

        //搜索
        search: function () {
            this.$router.push({
                path: "SearchVue",
            });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BookCityVue.vue